import { whoseLadder } from '../chunk-7HECKHIK.js';
import { METADATA_PATHS } from '../chunk-H56RYN3K.js';
import '../chunk-LUR5XN2Z.js';
import '../chunk-WVLHT3DL.js';
import '../chunk-STO6C45G.js';
import '../chunk-645XZPZL.js';
import { unwrapData } from '../chunk-RN57KPDG.js';
import '../chunk-RMLZ5HCT.js';
import '../chunk-BRBMP7SU.js';
import '../chunk-MZH5OJVQ.js';
import '../chunk-WKJCXPB2.js';
import '../chunk-I7OU4VPN.js';
import '../chunk-BFUJOKOR.js';
import '../chunk-6B5KO6TH.js';
import '../chunk-3QN2VZ56.js';
import '../chunk-LNDNXOJP.js';
import '../chunk-LVCDLPYA.js';
import '../chunk-UEXNJL5R.js';
import '../chunk-5WIUKZF6.js';
import '../chunk-SUGDLG4G.js';
import '../chunk-N5RLR4FB.js';
import '../chunk-O2TUCS6S.js';
import '../chunk-37LLPN7T.js';
import '../chunk-AEYXO6NC.js';
import '../chunk-FIGEXCM3.js';
import '../chunk-GPJ572YS.js';
import { globalSingleton } from '../chunk-N7SZ66QO.js';
import '../chunk-NCULDWVZ.js';
import '../chunk-LUSQNFVS.js';
import '../chunk-AHISJLEK.js';
import '../chunk-QXYP3KHC.js';
import '../chunk-M7KP2PIN.js';
import '../chunk-AHW5HTBY.js';
import '../chunk-PZ5AY32C.js';

// src/protocol-editor/types.ts
var OVERRIDE_TIERS = ["system", "customer", "org", "tenant", "user"];

// src/protocol-editor/schema.ts
var FIELD_ANNOTATIONS = [
  "x-merge",
  "x-merge-identity",
  "x-system-only",
  "x-code-bound",
  "x-format",
  "x-options-from",
  "x-empty-label"
];
function resolveNode(root, node) {
  if (!node) return { node: {}, nullable: false };
  let nullable = false;
  let current = node;
  const outer = { description: node.description, title: node.title, default: node.default };
  for (let guard = 0; guard < 8; guard += 1) {
    if (current.$ref) {
      const name = current.$ref.replace(/^#\/\$defs\//, "");
      const target = root.$defs?.[name];
      if (!target) break;
      current = { ...target, title: void 0, ...pickDefined(current, FIELD_ANNOTATIONS) };
      continue;
    }
    const union = current.anyOf ?? current.oneOf;
    if (union) {
      const members = union.filter((member) => member.type !== "null");
      if (members.length < union.length) nullable = true;
      if (members.length === 1) {
        current = { ...members[0], ...pickDefined(current, FIELD_ANNOTATIONS) };
        continue;
      }
    }
    break;
  }
  return {
    node: {
      ...current,
      description: outer.description ?? current.description,
      title: outer.title ?? current.title,
      default: outer.default !== void 0 ? outer.default : current.default
    },
    nullable
  };
}
function pickDefined(node, keys) {
  const out = {};
  for (const key of keys) {
    if (node[key] !== void 0) out[key] = node[key];
  }
  return out;
}
function typeOf(node) {
  return Array.isArray(node.type) ? node.type.find((t) => t !== "null") : node.type;
}
function fieldKind(root, node) {
  const { node: resolved } = resolveNode(root, node);
  if (resolved.enum && resolved.enum.length) return "enum";
  if ((resolved.anyOf ?? resolved.oneOf)?.length) return "json";
  const type = typeOf(resolved);
  if (type === "boolean") return "boolean";
  if (type === "integer") return "integer";
  if (type === "number") return "number";
  if (type === "string") return "string";
  if (type === "array") {
    const rule = resolved["x-merge"];
    if (rule === "keyed") return "keyed-list";
    if (rule === "union") {
      const item = fieldKind(root, resolved.items);
      return item === "string" || item === "integer" || item === "number" || item === "enum" ? "value-list" : "json";
    }
    return "json";
  }
  if (type === "object" || resolved.properties) {
    if (resolved.properties && Object.keys(resolved.properties).length) return "object";
    const values = resolved.additionalProperties;
    if (values && typeof values === "object") {
      const inner = fieldKind(root, values);
      if (inner === "number" || inner === "integer" || inner === "string" || inner === "boolean") return "map";
    }
    return "json";
  }
  return "json";
}
function identityFields(root, node) {
  return resolveNode(root, node).node["x-merge-identity"] ?? [];
}
function itemNode(root, node) {
  return resolveNode(root, resolveNode(root, node).node.items).node;
}
function isChainField(root, node) {
  return resolveNode(root, node).node["x-format"] === "chain";
}
function mapValueNode(root, node) {
  const values = resolveNode(root, node).node.additionalProperties;
  return values && typeof values === "object" ? resolveNode(root, values).node : {};
}
var ACRONYMS = {
  abi: "ABI",
  idl: "IDL",
  id: "ID",
  ids: "IDs",
  url: "URL",
  evm: "EVM",
  utxo: "UTXO",
  json: "JSON"
};
var RENAMED = { chain_id: "Chain", chain_ids: "Chains" };
function fieldLabel(name, node) {
  const title = node?.title;
  if (title && title.toLowerCase().replace(/\s+/g, "_") !== name.toLowerCase()) return title;
  if (RENAMED[name]) return RENAMED[name];
  const words = name.split("_").filter(Boolean).map((word) => ACRONYMS[word.toLowerCase()] ?? word);
  const text = words.join(" ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}
function tableColumns(root, listNode) {
  const item = itemNode(root, listNode);
  const identity = identityFields(root, listNode);
  const simple = Object.entries(item.properties ?? {}).filter(([name, prop]) => {
    if (identity.includes(name)) return false;
    const kind = fieldKind(root, prop);
    return kind === "string" || kind === "integer" || kind === "number" || kind === "boolean" || kind === "enum";
  }).map(([name]) => name);
  return [...identity, ...simple];
}

// src/protocol-editor/patch.ts
var PATCH_MARKER = "$patch";
var DELETE_FROM_LIST_PREFIX = "$deleteFromPrimitiveList/";
function isObject(value) {
  return !!value && typeof value === "object" && !Array.isArray(value);
}
function getAt(source, path) {
  let cursor = source;
  for (const key of path) {
    if (!isObject(cursor)) return void 0;
    cursor = cursor[key];
  }
  return cursor;
}
function setAt(patch, path, value) {
  if (path.length === 0) return isObject(value) ? { ...value } : patch;
  const [head, ...rest] = path;
  if (rest.length === 0) return { ...patch, [head]: value };
  const child = isObject(patch[head]) ? patch[head] : {};
  return { ...patch, [head]: setAt(child, rest, value) };
}
function unsetAt(patch, path) {
  const [head, ...rest] = path;
  if (head === void 0 || !(head in patch)) return patch;
  if (rest.length === 0) {
    const { [head]: _dropped, ...kept } = patch;
    return kept;
  }
  const child = patch[head];
  if (!isObject(child)) return patch;
  const next = unsetAt(child, rest);
  if (Object.keys(next).length === 0) {
    const { [head]: _emptied, ...kept } = patch;
    return kept;
  }
  return { ...patch, [head]: next };
}
function isEmptyPatch(patch) {
  return !patch || Object.keys(patch).length === 0;
}
function removalKey(path) {
  const field = path[path.length - 1];
  return { parent: path.slice(0, -1), key: `${DELETE_FROM_LIST_PREFIX}${field}`, field };
}
function listAt(patch, path) {
  const value = getAt(patch, path);
  return Array.isArray(value) ? value : [];
}
function writeList(patch, path, values) {
  return values.length ? setAt(patch, path, values) : unsetAt(patch, path);
}
function addListValue(patch, path, value) {
  const { parent, key } = removalKey(path);
  const removals = listAt(patch, [...parent, key]);
  let next = writeList(patch, [...parent, key], removals.filter((v) => v !== value));
  const current = listAt(next, path);
  if (!current.includes(value)) next = writeList(next, path, [...current, value]);
  return next;
}
function removeListValue(patch, path, value, { inherited }) {
  let next = writeList(patch, path, listAt(patch, path).filter((v) => v !== value));
  if (inherited) {
    const { parent, key } = removalKey(path);
    const removals = listAt(next, [...parent, key]);
    if (!removals.includes(value)) next = writeList(next, [...parent, key], [...removals, value]);
  }
  return next;
}
function restoreListValue(patch, path, value) {
  const { parent, key } = removalKey(path);
  return writeList(patch, [...parent, key], listAt(patch, [...parent, key]).filter((v) => v !== value));
}
function sameIdentity(entry, identity, fields) {
  if (!isObject(entry)) return false;
  return fields.every((name) => normalize(entry[name]) === normalize(identity[name]));
}
function normalize(value) {
  if (value === void 0 || value === "") return null;
  if (typeof value === "string" && /^0x[0-9a-fA-F]+$/.test(value)) return value.toLowerCase();
  if (Array.isArray(value)) return JSON.stringify(value.map(normalize).map(String).sort());
  return value;
}
function identityOf(entry, fields) {
  const out = {};
  for (const name of fields) out[name] = entry[name] ?? null;
  return out;
}
function upsertEntry(patch, path, fields, identity, values) {
  const list = listAt(patch, path);
  const at = list.findIndex((entry2) => sameIdentity(entry2, identity, fields));
  const base = at >= 0 && isObject(list[at]) ? list[at] : identityOf(identity, fields);
  const { [PATCH_MARKER]: marker, ...kept } = base;
  const entry = { ...kept, ...identityOf(identity, fields), ...values };
  if (marker === "replace") entry[PATCH_MARKER] = "replace";
  const next = at >= 0 ? list.map((e, i) => i === at ? entry : e) : [...list, entry];
  return writeList(patch, path, next);
}
function resetEntryField(patch, path, fields, identity, field) {
  const list = listAt(patch, path);
  const next = list.map((entry) => {
    if (!sameIdentity(entry, identity, fields) || !isObject(entry)) return entry;
    const { [field]: _dropped, ...kept } = entry;
    return kept;
  }).filter((entry) => !isObject(entry) || Object.keys(entry).some((k) => !fields.includes(k)));
  return writeList(patch, path, next);
}
function removeEntry(patch, path, fields, identity, { inherited }) {
  const kept = listAt(patch, path).filter((entry) => !sameIdentity(entry, identity, fields));
  const next = inherited ? [...kept, { ...identityOf(identity, fields), [PATCH_MARKER]: "delete" }] : kept;
  return writeList(patch, path, next);
}
function restoreEntry(patch, path, fields, identity) {
  const next = listAt(patch, path).filter(
    (entry) => !(sameIdentity(entry, identity, fields) && isObject(entry) && entry[PATCH_MARKER] === "delete")
  );
  return writeList(patch, path, next);
}
function sliceOf(patch, fields) {
  const out = {};
  for (const field of fields) {
    if (field in patch) out[field] = patch[field];
    const removal = `${DELETE_FROM_LIST_PREFIX}${field}`;
    if (removal in patch) out[removal] = patch[removal];
  }
  return out;
}
function withSlice(patch, fields, slice) {
  const out = { ...patch };
  for (const field of fields) {
    delete out[field];
    delete out[`${DELETE_FROM_LIST_PREFIX}${field}`];
  }
  return { ...out, ...slice };
}

// src/protocol-editor/origins.ts
function originPath(parts) {
  return parts.join(".");
}
function originAt(origins, path) {
  return origins?.fields[path];
}
function deepestOriginUnder(origins, path) {
  if (!origins) return void 0;
  let found;
  for (const [key, origin] of Object.entries(origins.fields)) {
    if (key !== path && !key.startsWith(`${path}.`)) continue;
    if (!found || rank(origin.tier) > rank(found.tier)) found = origin;
  }
  return found;
}
function isRowField(key) {
  return /\.\d+\.[^.]+$/.test(key);
}
function originCounts(origins, prefixes) {
  const counts = {};
  if (!origins) return counts;
  for (const [key, origin] of Object.entries(origins.fields)) {
    if (!prefixes.some((p) => key === p || key.startsWith(`${p}.`))) continue;
    if (isRowField(key)) continue;
    counts[origin.tier] = (counts[origin.tier] ?? 0) + 1;
  }
  return counts;
}
function removedAt(origins, path) {
  return (origins?.removed ?? []).filter((entry) => entry.path === path);
}
function removedUnder(origins, prefixes) {
  return (origins?.removed ?? []).filter(
    (entry) => prefixes.some((p) => entry.path === p || entry.path.startsWith(`${p}.`))
  );
}
function downstreamAt(downstream, path) {
  return downstream?.fields[path];
}
function downstreamUnder(downstream, prefixes) {
  if (!downstream) return 0;
  const hit = (key) => !prefixes || prefixes.some((p) => key === p || key.startsWith(`${p}.`));
  return Object.keys(downstream.fields).filter((key) => hit(key) && !isRowField(key)).length + downstream.added.filter((a) => hit(a.path)).length;
}
function overriddenBelow(origins, downstream, tier) {
  const byField = /* @__PURE__ */ new Map();
  for (const [path, note] of Object.entries(downstream?.fields ?? {})) {
    if (owner(origins, path)?.tier !== tier) continue;
    const [field = path] = path.split(".");
    const tiers = byField.get(field) ?? /* @__PURE__ */ new Set();
    for (const setter of [...note.also ?? [], note]) tiers.add(String(setter.tier));
    byField.set(field, tiers);
  }
  return [...byField].map(([field, tiers]) => ({
    field,
    tiers: [...tiers].sort((a, b) => rank(a) - rank(b))
  }));
}
function owner(origins, path) {
  const parts = path.split(".");
  for (let end = parts.length; end > 0; end -= 1) {
    const found = origins?.fields[parts.slice(0, end).join(".")];
    if (found) return found;
  }
  return void 0;
}
function downstreamAddedAt(downstream, path) {
  return (downstream?.added ?? []).filter((entry) => entry.path === path);
}
function problemsAt(problems, path, { within = false } = {}) {
  return (problems ?? []).filter(
    (problem) => problem.path === path || within && !!problem.path?.startsWith(`${path}.`)
  );
}
function problemsUnder(problems, prefixes) {
  return (problems ?? []).filter(
    (problem) => prefixes.some((p) => problem.path === p || !!problem.path?.startsWith(`${p}.`))
  ).length;
}
function problemTextAt(detail, path) {
  if (detail.startsWith(`${path}: `)) return detail.slice(path.length + 2);
  if (detail.startsWith(`${path}.`)) return detail.slice(path.length + 1);
  const positioned = detail.match(new RegExp(`^${escapeRegExp(path)}\\[\\d+\\]: `));
  return positioned ? detail.slice(positioned[0].length) : detail;
}
function escapeRegExp(text) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function rank(tier) {
  return OVERRIDE_TIERS.indexOf(tier);
}

// src/protocol-editor/source.ts
var schemaCache = globalSingleton(
  "protocol-editor/schema-cache",
  () => /* @__PURE__ */ new Map()
);
function createApiProtocolDefinitionSource(client, options = {}) {
  const at = (verb, sub) => options.url ? options.url(verb, sub) : `${METADATA_PATHS.protocols}${sub}`;
  const item = (protocolId) => `/${encodeURIComponent(protocolId)}`;
  const who = whoseLadder(options);
  const query = (extra = {}) => ({ ...who, ...extra });
  const invalidate = (protocolId) => {
    client.invalidateMatching(at("GET", ""));
    client.invalidateMatching(at("GET", item(protocolId)));
  };
  return {
    async list() {
      const page = unwrapData(
        await client.get(at("GET", ""), { query: query(), cacheTtlMs: 0 })
      );
      return page?.items ?? [];
    },
    async get(protocolId) {
      const body = unwrapData(
        await client.get(at("GET", item(protocolId)), { query: query(), cacheTtlMs: 0 })
      );
      return body?.protocol ?? null;
    },
    schema() {
      const url = at("GET", "/schema");
      let pending = schemaCache.get(url);
      if (!pending) {
        pending = client.get(url).then((res) => unwrapData(res));
        pending.catch(() => schemaCache.delete(url));
        schemaCache.set(url, pending);
      }
      return pending;
    },
    async preview(protocolId, tier, patch) {
      return unwrapData(
        await client.post(
          at("ANY", `${item(protocolId)}/preview`),
          { definition_patch: patch },
          { query: query({ scope: tier }) }
        )
      );
    },
    async save(protocolId, tier, patch, options2 = {}) {
      const body = { definition_patch: patch };
      if (options2.baseRevision !== void 0) body.base_revision = options2.baseRevision;
      unwrapData(
        await client.put(at("ANY", item(protocolId)), body, { query: query({ scope: tier }) })
      );
      invalidate(protocolId);
    },
    async clear(protocolId, tier, options2 = {}) {
      const extra = { scope: tier };
      if (options2.baseRevision) extra.base_revision = options2.baseRevision;
      unwrapData(await client.delete(at("ANY", item(protocolId)), { query: query(extra) }));
      invalidate(protocolId);
    }
  };
}

export { DELETE_FROM_LIST_PREFIX, OVERRIDE_TIERS, PATCH_MARKER, addListValue, createApiProtocolDefinitionSource, deepestOriginUnder, downstreamAddedAt, downstreamAt, downstreamUnder, fieldKind, fieldLabel, getAt, identityFields, isChainField, isEmptyPatch, isRowField, itemNode, mapValueNode, originAt, originCounts, originPath, overriddenBelow, problemTextAt, problemsAt, problemsUnder, removeEntry, removeListValue, removedAt, removedUnder, resetEntryField, resolveNode, restoreEntry, restoreListValue, setAt, sliceOf, tableColumns, unsetAt, upsertEntry, withSlice };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map